import {
  Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Table, TableBody, TableCell, TableContainer, TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { FaMedium, FaTree } from 'react-icons/fa';
import { GiNewspaper } from 'react-icons/gi';
import { connect } from 'react-redux';
import GenericBulten from 'src/components/GenericBulletin';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import { getUser, moneyFormat } from 'src/utils/Common';
import { setMaterialQuan, setMaterialSelection, setMaterialFilterKey } from '../../store/actions';
import BarkodPopup from '../BarcodePopup';
import ComplexSwipeContent from '../ComplexSwipeContent';
import EditMaterial from './edit';
import { AiOutlineCheckSquare } from 'react-icons/ai';

const useStyles = makeStyles({
  tableContainer: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
    minHeight: 500,
  },
  table: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
  },
  tableCell: {
    maxWidth: 10,
  },
  tableCell1: {
    paddingLeft: 0,
    paddingRight: 2,
    maxWidth: 7,
  },
});

const MaterialTable = (props) => {
  const classes = useStyles();
  const [openEdit, setOpenEdit] = React.useState(false);
  const [materialCode, setMaterialCode] = React.useState('');
  const [materialDesc, setMaterialDesc] = React.useState('');
  const [materialId, setMaterialId] = React.useState('');
  const [UseMax, setUseMax] = React.useState(10);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [muadilOpen, setMuadilOpen] = React.useState(false);
  const [muadilParam, setMuadilParam] = React.useState('');
  const [muadilTitle, setMuadilTitle] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [ImagePopup, setImagePopup] = React.useState(false);
  const [ImageUrl, setImageUrl] = React.useState('');
  const [sparePartMap, setSparePartMapData] = React.useState([]);
  const [sparePartMessage, setSparePartMessage] = React.useState('');

  const selected = props.materials[props.defect] || [];
  let selectedAll = [];
  if (props.selectedDefects) {
    props.selectedDefects.forEach((d) => {
      if (props.materials[d]) { selectedAll = [...selectedAll, ...props.materials[d]]; }
    });
  }
  const handleClick = (name, desc, id, Max, disabled, message) => {
    axios
      .get(`/GetSparePartMapList` + '/' + id)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setSparePartMapData(response.data);
          var materiaLFilteredData = props.materials.Data.filter(m => m.MaterialId == response.data[0].NewMaterialId);
          if (materiaLFilteredData !== undefined && materiaLFilteredData.length > 0) {
            message = t('MaterialHasEquivalent') + ' ' + name + ' -> ' + materiaLFilteredData[0].MaterialCode;
            setSparePartMessage(message);
          }
        } else {
          setSparePartMessage('');
        }
        if (disabled) {
          return;
        }
        const selectedIndex = selected.indexOf(name);

        let newSelected = [];

        if (selectedIndex === -1) {
          // Add
          newSelected = [...selected, name];
          setOpenEdit(true);
          setMaterialCode(name);
          setMaterialDesc(desc);
          setMaterialId(id);
          setUseMax(parseInt(Max));
        } else {
          // Remove
          newSelected = [...selected.slice(0, selectedIndex),
          ...selected.slice(selectedIndex + 1)
          ];
        }
        props.setMaterialFilterKey('');
        props.setMaterialSelection(props.defect, newSelected);
      })
      .catch(error => { });
  };

  const handleBarkodClose = (barkod) => {
    props.setOpenBarkod(false);
    if (barkod.length === undefined) {
      return;
    }
    const row = props.materials.materialsTable[barkod];
    // if (row === undefined) {
    //   setUyari(barkod + " nolu malzeme bu ürün için tanımlı değildir!..");
    //   setOpen(true);
    //   return;
    // }
    if (selected.indexOf(row.MaterialCode) === -1) {
      props.setMaterialSelection(props.defect, [...selected, row.MaterialCode]);
    }
    setOpenEdit(true);
    setMaterialCode(row.MaterialCode);
    setMaterialDesc(row.MaterialDesc);
    setMaterialId(row.MaterialId)
    setUseMax(parseInt(row.UseQuantity));
  };

  const handleCloseEdit = (value) => {
    setOpenEdit(false);
    props.setMaterialQuan(materialCode, value);
  };

  const isSelected = (name) => (selected && selected.indexOf(name) !== -1);
  const isUsedBefore = (name) => (selectedAll && selectedAll.indexOf(name) !== -1);

  const highlight = (text) => (
    <Highlighter
      searchWords={[props.materials.filterKey]}
      autoEscape
      textToHighlight={text}
    />
  );

  const malzemeGoster = (materialCode) => {
    const data = {
      MaterialCode: materialCode,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/SiriusMaterialImage', data, config)
      .then((response) => {
        const fileURL = URL.createObjectURL(response.data);
        // newWindow.location = fileURL;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURL);
        setImagePopup(true);
      }).catch((error) => {

      });
  };

  const MuadilMalzemeGoster = (txt, malzeme) => {
    setMuadilParam(txt);
    setMuadilTitle(malzeme);
    setMuadilOpen(true);
  };

  const handleBultenOpen = (param) => {
    setBultenParam(param);
    setBultenOpen(true);
  };

  const getMaterialRow = (row, index) => {
    if (row === undefined) {
      return '';
    }
    const labelId = `enhanced-table-checkbox-${index}`;
    const isItemSelected = isSelected(row.MaterialCode);
    const isItemUsedBefore = isUsedBefore(row.MaterialCode);
    const disabled = isItemUsedBefore && !isItemSelected;
    return (
      <SwipeableListItem
        dense
        swipeLeft={{
          content: (
            <ComplexSwipeContent
              icon={<FaMedium size={30} />}
              label={t('lblMuadil')}
              position="right"
              css="muadil"
            />
          ),
          action: () => MuadilMalzemeGoster(row.ActiveEquivalent, row.MaterialCode)
        }}
        swipeRight={{
          content: (
            <ComplexSwipeContent
              icon={<GiNewspaper size={30} />}
              label={t('lblMalzemeBulteni')}
              position="left"
              css="muadil"
            />
          ),
          action: () => handleBultenOpen(row.MaterialCode)
        }}
        blockSwipe={props.readonly}
        key={row.MaterialCode}
      >
        <TableRow
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          selected={isItemSelected}
        >
          <TableCell className={classes.tableCell}>
            <ImageSearchIcon
              onClick={() => malzemeGoster(row.MaterialCode)}
              color="primary"
            />
          </TableCell>
          <TableCell
            scope="row"
            onClick={() => handleClick(
              row.MaterialCode, 
              row.MaterialDesc, 
              row.MaterialId,
              row.UseQuantity, 
              disabled,
              ''
            )}
          >
            <Grid container spacing={0}>
              <Grid style={{ color: row.CanBeOrdered ? 'inherit' : 'red' }} item xs={11}>
                <b>{highlight(row.MaterialCode)}</b>
                {' '}
                {highlight(row.MaterialDesc)}
                <b>
                  {row.PriceVisible ? <>
                    <Chip
                    size="small"
                    label={`${moneyFormat(row.Price, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`}
                  /></>:''}
                  <Chip
                    size="small"
                    label={`Ref:${row.Ref}`}
                  />
                  {row.ActiveEquivalent.length > 0 && (
                    <Chip
                      color="secondary"
                      size="small"
                      label="M"
                    />
                  )}
                </b>
                {
                  row.HistoricalBom === 0
                    ? <AiOutlineCheckSquare style={{ color: 'green' }} size="20" />
                    : <FaTree style={{ color: 'orange' }} size="20" />
                }
              </Grid>
              <Grid item xs={1} onClick={() => handleClick(
                  row.MaterialCode,
                  row.MaterialDesc,
                  row.MaterialId,
                  row.UseQuantity,
                  disabled,
                  ''
                )}
                >
                <Checkbox
                  checked={isItemSelected || isItemUsedBefore}
                  inputProps={{ 'aria-labelledby': labelId }}
                  color="primary"
                  disabled={disabled}
                />
              </Grid>
            </Grid>
          </TableCell>

        </TableRow>
      </SwipeableListItem>
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <EditMaterial
        open={openEdit}
        defect={props.defect}
        materialCode={materialCode}
        materialDesc={materialDesc}
        materialId={materialId}
        sparePartMessage={sparePartMessage}
        value={1}
        min={1}
        max={99}
        onClose={handleCloseEdit}
      />
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblMalzemeAitBulten')}
        </DialogTitle>
        <DialogContent>
          <GenericBulten param={bultenParam} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={muadilOpen}
        onClose={() => setMuadilOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {muadilTitle}
          {' '}
          {t('lblMalzemeninBulteni')}
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table size="small" aria-label="material table">
              <TableBody className={classes.table}>
                {muadilParam.length === 0 ? '...' : muadilParam.split(',').map((m, index) => {
                  const row = props.materials.materialsTable[m];
                  if (row === undefined) {
                    return <div>{`${m} ${t('lblMuadilBomUyari')}`}</div>;
                  }
                  return getMaterialRow(row, index);
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setMuadilOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <TableContainer>
        <Table size="small" aria-label="material table">
          <TableBody className={classes.table}>
            {(props.materials.filtered) && props.materials.filtered.sort((s) => (isUsedBefore(s.MaterialCode) ? -1 : 1)).slice(0, props.GosterimAdet).map((row, index) => getMaterialRow(row, index))}
          </TableBody>
        </Table>
      </TableContainer>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={props.openBarkod}
        ScanTime={1000}
      />
      <Dialog
        open={ImagePopup}
        fullWidth
        maxWidth="sm"
        onClose={() => setImagePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
      </Dialog>
    </>
  );
};


const mapStateToProps = (state) => ({
  materials: state.materialReducer,
  selectedDefects: state.defectReducer.selected,
});

const mapDispatchToProps = {
  setMaterialSelection,
  setMaterialQuan,
  setMaterialFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialTable);
